module.exports = __webpack_public_path__ + "static/img/bg-ar.b6c38be7.webp";